import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";

const navItems = [
    { path: "/", label: "Home" },
    { path: "/services", label: "Solutions" },
    { path: "/finder", label: "Browse Warehouses" },
    { path: "/3pl_booking", label: "Request Match" },
    { path: "/provider", label: "List Your 3PL" },
    { path: "/contact", label: "Contact" }
];

function Navbar() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isClientLoggedIn, setIsClientLoggedIn] = useState(false);

    useEffect(() => {
        const syncAuthState = () => {
            const token = localStorage.getItem("token");
            const clientToken = localStorage.getItem("clientToken");

            if (token) {
                setIsLoggedIn(true);
                setIsClientLoggedIn(false);
                return;
            }

            if (clientToken) {
                setIsLoggedIn(false);
                setIsClientLoggedIn(true);
                return;
            }

            setIsLoggedIn(false);
            setIsClientLoggedIn(false);
        };

        syncAuthState();
        window.addEventListener("storage", syncAuthState);

        return () => window.removeEventListener("storage", syncAuthState);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("clientToken");
        localStorage.removeItem("userType");
        setIsLoggedIn(false);
        setIsClientLoggedIn(false);
    };

    const userType = localStorage.getItem("userType");

    return (
        <nav className="navbar navbar-expand-lg fixed-top site-navbar">
            <div className="container">
                <Link className="navbar-brand site-brand" to="/">
                    <span>3PL Search</span>
                    <small>Warehouse sourcing and quote support</small>
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav mx-auto align-items-lg-center">
                        {navItems.map(({ path, label }) => (
                            <li key={path} className="nav-item">
                                <NavLink
                                    className={({ isActive }) => `nav-link site-nav-link ${isActive ? "active" : ""}`}
                                    to={path}
                                >
                                    {label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>

                    <div className="site-navbar-actions">
                        <Link className="site-secondary-cta" to="/finder">
                            Find a 3PL
                        </Link>

                        {isLoggedIn || isClientLoggedIn ? (
                            <div className="dropdown">
                                <button
                                    className="btn site-profile-btn dropdown-toggle"
                                    type="button"
                                    id="profileMenu"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <FaUserCircle size={28} />
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileMenu">
                                    <li>
                                        {userType === "Client" ? (
                                            <Link className="dropdown-item" to="/clientDetails">
                                                Client dashboard
                                            </Link>
                                        ) : userType === "Marketer" ? (
                                            <Link className="dropdown-item" to="/marketerDetails">
                                                Marketer dashboard
                                            </Link>
                                        ) : (
                                            <>
                                                <Link className="dropdown-item" to="/userDetails">
                                                    My dashboard
                                                </Link>
                                                <Link className="dropdown-item" to="/userDetails/userWishList">
                                                    Saved warehouses
                                                </Link>
                                            </>
                                        )}
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={handleLogout}>
                                            Logout
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        ) : (
                            <div className="dropdown">
                                <button
                                    className="btn site-primary-cta dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Sign in
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    <li><Link className="dropdown-item" to="/userLogin">Buyer login</Link></li>
                                    <li><Link className="dropdown-item" to="/clientLogin">Provider login</Link></li>
                                    <li><Link className="dropdown-item" to="/admin">Admin login</Link></li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
